var map = {
	"./booster.svg": "b030",
	"./moderator.svg": "f88b",
	"./rank_captain.svg": "bf6e",
	"./rank_colonel.svg": "ca6e",
	"./rank_corporal.svg": "1d16",
	"./rank_lance_corporal.svg": "9e29",
	"./rank_lieutenant.svg": "7370",
	"./rank_major.svg": "1b05",
	"./rank_private.svg": "b039",
	"./rank_private_first_class.svg": "1e69",
	"./rank_sergeant.svg": "2dbb",
	"./rank_staff_sergeant.svg": "bcdb",
	"./worshipper.svg": "f903",
	"./zeus.svg": "8b86"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5981";